export default "__VITE_ASSET__BZO9q2cC__"